const VideoComponent = () => {
    return (
        <div className="background-video">
        <video autoPlay loop muted playsInline width={'100%'}>
            <source src='../video/background.mp4' type="video/mp4" />
        </video>
        </div>
    );
    }
export default VideoComponent;